/**
 * Whether authenticated UI should be presented while the session is resolving.
 *
 * Android paints the app shell before AsyncStorage hydration so Samsung One UI
 * cannot expose a blank window after dropping the system splash. During that
 * window, and while a stored access token is being refreshed, descendants must
 * make the same optimistic assumption as the shell. A rejected refresh clears
 * the token, after which the Android layout redirects to login.
 *
 * This is for presentation only. API calls and paid actions must still use the
 * normal token-validation path.
 */
export function shouldPresentAuthenticated({
  platform,
  isAuthHydrated,
  token,
  isTokenExpired = false,
}) {
  if (platform === 'android') {
    return !isAuthHydrated || !!token;
  }

  return !!token && !isTokenExpired;
}

/**
 * A stored Android token represents a refreshable session even when the access
 * token itself has expired. API calls perform the refresh on demand.
 */
export function hasActionableSession({
  platform,
  token,
  isTokenExpired = false,
}) {
  if (!token) return false;
  return platform === 'android' || !isTokenExpired;
}
